module.exports = __webpack_public_path__ + "static/media/logo.b5919b3c.svg";